"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kitchenLog = void 0;
function kitchenLog(type, data) {
    if (window.__KITCHEN_GOD__) {
        window.__KITCHEN_GOD__.log(type, data);
    }
}
exports.kitchenLog = kitchenLog;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2l0Y2hlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlsL2tpdGNoZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsVUFBVSxDQUFDLElBQVksRUFBRSxJQUFTO0lBQ2hELElBQUssTUFBYyxDQUFDLGVBQWUsRUFBRTtRQUNsQyxNQUFjLENBQUMsZUFBZSxDQUFDLEdBQUcsQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7S0FDakQ7QUFDSCxDQUFDO0FBSkQsZ0NBSUMifQ==